import { Suggestion } from '../types/firestore';
import { getSuggestionWorkflowStage, normalizeSuggestionStatus } from './suggestionWorkflow';

export type SuggestionBucket =
  | 'all'
  | 'pre_vote'
  | 'voting'
  | 'post_vote'
  | 'implementation'
  | 'history';

export interface SuggestionBucketDefinition {
  key: SuggestionBucket;
  label: string;
}

export const SUGGESTION_BUCKETS: SuggestionBucketDefinition[] = [
  { key: 'all', label: 'Wszystkie' },
  { key: 'pre_vote', label: 'Do opracowania' },
  { key: 'voting', label: 'Głosowanie' },
  { key: 'post_vote', label: 'Po głosowaniu' },
  { key: 'implementation', label: 'Realizacja' },
  { key: 'history', label: 'Archiwum' },
];

export const getSuggestionBucket = (
  suggestion: Pick<Suggestion, 'workflowVersion' | 'status' | 'isArchived'>
): SuggestionBucket => {
  const status = normalizeSuggestionStatus(suggestion.status);
  if (suggestion.isArchived === true || status === 'archived') {
    return 'history';
  }

  const stage = getSuggestionWorkflowStage(suggestion);
  if (stage === 'pre_vote') {
    return 'pre_vote';
  }
  if (stage === 'voting') {
    return 'voting';
  }
  if (stage === 'post_vote') {
    return 'post_vote';
  }
  if (stage === 'implementation') {
    return 'implementation';
  }

  return 'history';
};

export const matchesSuggestionBucket = (
  suggestion: Pick<Suggestion, 'workflowVersion' | 'status' | 'isArchived'>,
  bucket: SuggestionBucket
): boolean => {
  if (bucket === 'all') {
    return true;
  }

  if (bucket === 'history') {
    return getSuggestionBucket(suggestion) === 'history';
  }

  return getSuggestionBucket(suggestion) === bucket;
};
